var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "foundation", rawName: "v-foundation" }],
      staticClass: "ContentsManage"
    },
    [
      _c("contents-header", { staticClass: "globalHeader" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "globalBody" },
        [
          _c("contents-nav", {
            staticClass: "globalBody__nav",
            on: { "menu-selected": _vm.openModal }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "globalBody__contents" },
            [
              _c("articles-header", {
                staticClass: "globalBody__contents__item--fixed",
                on: { "create-new-article": _vm.openModal }
              }),
              _vm._v(" "),
              _c("contents-toolbar", {
                staticClass: "globalBody__contents__item--fixed",
                on: { "toolbar-selected": _vm.openModal }
              }),
              _vm._v(" "),
              _c("articles-manage", {
                staticClass: "globalBody__contents__item",
                on: { "menu-selected": _vm.openModal }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalVisible
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "escape-key",
                  rawName: "v-escape-key",
                  value: _vm.closeModal,
                  expression: "closeModal"
                }
              ],
              staticClass: "reveal-overlay cm-reveal-overlay",
              attrs: { id: "contentsMenuModal" },
              on: {
                click: function($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  return _vm.closeModal($event)
                }
              }
            },
            [
              _vm.isSiteUrl
                ? _c(_vm.siteUrlState.modalName, {
                    tag: "component",
                    staticClass: "reveal cm-reveal-overlay__reveal",
                    attrs: { siteUrlModel: _vm.siteUrlState },
                    on: { submit: _vm.closeModal, close: _vm.closeModal }
                  })
                : _c(_vm.modalState.modalName, {
                    tag: "component",
                    staticClass: "reveal cm-reveal-overlay__reveal",
                    attrs: { articleData: _vm.modalState.data },
                    on: { submit: _vm.submitData, close: _vm.closeModal }
                  })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }